export default __webpack_public_path__ + "static/media/send.button.fcf5e339.svg";